import React from 'react'
import ProductItem from '../elements/ProductItem'

function Shop() {
  return (
    <div className='container pt-5 pb-5'>
    <ProductItem/>
    </div>
  )
}

export default Shop
